import React, { useEffect, useState } from 'react';
import { CommandInput, Command } from '@/components/shadcn/ui/command';
import { useUsers } from '@/hook/useUsers';
import { Users } from '@/entities/users';
import { UserForm } from '@/components/forms/userForm/userForm';
import TableView from '@/components/users/TableView';
import { useNavigate } from 'react-router-dom';


const UserPage = () => {
  const navigate = useNavigate();
  
  const [UsersPage, setUsersPage] = useState<Users[]>([]);
  const {
    users,
    open,
    updateColaboratorIdByEmail,
    setOpen,
    editUser,
    setEditUser,
    updateUser,
    idToEdit,
    setIdToEdit,
    selectedUser,
    setSelectedUser,
  } = useUsers();

  const companyId = Number(localStorage.getItem("companyId"));

  

  useEffect(() => {
    setUsersPage(users);
  }, [users]);

  const handleUserSubmit = async (data: any) => {
    const dataUsers = {
      name: data.name,
      email: data.email,
      companyId,
      roleId: data.roleId,

    };
    if(data.colaboratorId) {
      const colaboratorId = data.colaboratorId;
      updateColaboratorIdByEmail(colaboratorId, data.email);
    }

    try {
      await updateUser(idToEdit, dataUsers);
    } catch (error) {
      console.error('Erro ao atualizar Usuário:', error);
    }
  };

  const alterOpen = (value: boolean) => {
    setOpen(value);
  };

  const handleUserSelect = (data: Users | undefined) => {
    setSelectedUser(data ? { ...data } : null);
  };  

  const handleSetEdit = (value: boolean) => {
    setEditUser(value);
  };

  const handleSetId = (id: number) => {
    setIdToEdit(id);
  };

  const handleUserDelete = (index: number) => {
    const confirmed = window.confirm("Tem certeza de que deseja deletar este usuário?");
    if (!confirmed) return;
    const updatedUsers = [...UsersPage];
    updatedUsers.splice(index, 1);
    setUsersPage(updatedUsers);
  };

  return (
    <div className="min-h-screen bg-indigo-200 p-8">
      <div className="min-h-100 flex flex-col overflow bg-white rounded-md py-4 mx-8 mb-4">
        <div className="flex m-2 justify-between items-center pr-2">
          <h1 className="m-4 text-md font-medium">Usuários</h1>
          <div className="flex gap-6">
            <UserForm
              onUserSubmit={handleUserSubmit}
              isOpen={open}
              setOpen={alterOpen}
              setEdit={handleSetEdit}
              data2={editUser ? selectedUser : null}
              editing={editUser}
              setSelectedUser={handleUserSelect}
            />
            <Command className="flex items-center rounded-lg border-2 p-1 gap-1">
              <CommandInput placeholder="Pesquisar..." />
            </Command>
          </div>
        </div>
        <div>
          <TableView
            data={UsersPage}
            onUserDelete={handleUserDelete}
            open={open}
            setOpen={alterOpen}
            setSelectedUser={handleUserSelect}
            setEdit={handleSetEdit}
            setIdToEdit={handleSetId}
          />
        </div>
      </div>
    </div>
  );
};

export default UserPage;
